import { WarehouseInventoryMapperParameter, WarehouseInventoryFactory } from "@/v2/models/warehouse-inventories.js";
import mapperMixin from "@/v2/mixins/mapper.js";
import httpMixin from "@/v2/mixins/http.js";
import productMixin from "@/v2/mixins/products.js";
import warehouseMixin from "@/v2/mixins/warehouses.js";
import { VariableProduct } from "@/v2/models/products.js";

export default {
    mixins: [mapperMixin, httpMixin, productMixin, warehouseMixin],
    data() {
        return {
            warehouseInventoriesUrl: window.bo.warehouseInventoriesUrl,
            currentUserWarehouseInventoriesUrl: window.bo.currentUserWarehouseInventoriesUrl,
            advancedUomStockQuantity: window.bo.advancedUomStockQuantity,
        };
    },
    methods: {
        _warehouseInventoryMapper(warehouseInventory) {
            return {
                id: warehouseInventory.id,
                batch_id: warehouseInventory.batch_id,
                branch_id: warehouseInventory.branch_id, // warehouse_id
                balance: warehouseInventory.balance,
                physical_balance: warehouseInventory.physical_balance,
                sellable_balance: warehouseInventory.sellable_balance,
                product_id: warehouseInventory.product_id,
                product_parent_id: warehouseInventory.product_parent_id,
                conv_rate_group: warehouseInventory.conv_rate_group,
                product: warehouseInventory.product,
                product_type: warehouseInventory.product_type,
                is_matrix_product: warehouseInventory.is_matrix_product,
                stock_balance: warehouseInventory.stock_balance,
                stock_balance_id: warehouseInventory.stock_balance_id,
                warehouse: warehouseInventory.warehouse,
                created_at: warehouseInventory.created_at ? new Date(warehouseInventory.created_at) : null,
                updated_at: warehouseInventory.updated_at ? new Date(warehouseInventory.updated_at) : null,
                deleted_at: warehouseInventory.deleted_at ? new Date(warehouseInventory.deleted_at) : null,
            };
        },

        parseWarehouseInventory(warehouseInventory) {
            return WarehouseInventoryFactory.construct(
                this.createMapperParameter(new WarehouseInventoryMapperParameter()),
                warehouseInventory
            );
        },

        parseWarehouseInventories(warehouseInventories) {
            let parsedWarehouseInventories = [];

            warehouseInventories.forEach((warehouseInventoryData) => {
                const warehouseInventory = this.parseWarehouseInventory(warehouseInventoryData);
                parsedWarehouseInventories.push(warehouseInventory);
            });

            return parsedWarehouseInventories;
        },

        getWarehouseInventory(id, payload, success, failure) {
            return this.getData(
                this.warehouseInventoriesUrl + "/" + id,
                payload,
                (response) => {
                    success(this.parseWarehouseInventory(response.data));
                },
                failure
            );
        },

        getWarehouseInventories(payload, success, failure, showLoadingScreen = true) {
            return this.getData(
                this.warehouseInventoriesUrl,
                payload,
                (response) => {
                    success(this.parseWarehouseInventories(response.data.data), response.data.meta);
                },
                failure,
                showLoadingScreen
            );
        },
        // Get current user warehouse inventory
        getCurrentUserWarehouseInventories(payload, success, failure, showLoadingScreen = true) {
            return this.getData(
                this.currentUserWarehouseInventoriesUrl,
                payload,
                (response) => {
                    success(this.parseWarehouseInventories(response.data.data), response.data.meta);
                },
                failure,
                showLoadingScreen
            );
        },

        // get product stock quantity
        getProductStockQuantity(inventories, product) {
            if (product instanceof VariableProduct) {
                if (this.advancedUomStockQuantity) {
                    product = product.getBaseVariation();
                } else {
                    product = product.getSelectedVariation();
                    // If the selected variation has no stock_balance, then use the base variation's stock_balance
                    // if (!inventories[product.id]?.stock_balance) {
                    //     product = product.getBaseVariation();
                    // }
                }
            }
            return inventories[product.id]?.stock_balance;
        },
    },
};
